import { OptionTypes } from '@/types';
import { Box, Button, Paper } from '@mui/material';
import { routes } from 'constants/index';
import { useBookingTimer } from 'context/BookingTimerContext';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const Option: React.FC<OptionTypes> = ({
  name,
  icon,
  unitCode,
  btnName,
  locationCode,
  code,
  source,
}) => {
  const { startTimer } = useBookingTimer();
  const navigate = useNavigate();

  const navigateToSearchEngine = (unitCode: string) => {
    const params = new URLSearchParams();

    if (locationCode) params.append('locationCode', locationCode.toLowerCase());
    if (code) params.append('code', code);
    if (source) params.append('source', source);

    startTimer();

    navigate(`${routes.saerch}/${unitCode}?${params.toString()}`);
  };

  return (
    <Paper
      className="option-style"
      onClick={() => navigateToSearchEngine(unitCode)}
    >
      <Box mb={2} display="flex" justifyContent="center">
        <img src={icon} alt="Thrifty" />
      </Box>
      {/* <Typography variant="h6" gutterBottom>
        {name}
      </Typography> */}
      <Button variant="contained" color="primary">
        {btnName}
      </Button>
    </Paper>
  );
};
